import { IFetchFacialRecognitionDTO } from 'shared/domain/dtos';
import { IFacialRecognitionsRepository } from 'shared/domain/repositories';

export class FetchFacialRecognitionUseCase {
  constructor(
    private facialRecognitionsRepository: IFacialRecognitionsRepository,
  ) {}

  public async execute({
    process,
    onboardingType,
  }: IFetchFacialRecognitionDTO) {
    return this.facialRecognitionsRepository.findOne({
      process,
      onboardingType,
    });
  }
}
